export const intros=[{
    title:"Lerne mit Heldenzeit wie du in Zeiten wie diesen ein Held für dich und deine Mitmenschen sein kannst.",
    text:"(Heldenzeit - Gerade in der aktuellen Situation kann jeder zum Held werden!)"
},{
    title:"Sammle so viele Punkte wie möglich in den Kategorien:   Helfen - Gesundheit - Aktivität und werde so zum Held dieser Zeit!",
 },{
    title:"Bring eigene Ideen ein und inspiriere andere ihren Alltag aktiv und kreativ zu gestalten.",
 }]